import Step from '@mui/material/Step';
import LoginViewModel from './viewModel';
import CpfStep from './CpfStep';
import CodeMethodStep from './CodeMethodStep';
import CodeStep from './CodeStep';
import SuccessStep from './SuccessStep';
import { Card, FooterProgress, HiddenStepper } from './styled';

type LoginProps = {
  onContinueWithoutLogin?: () => void | Promise<void>;
  onSuccess?: (token: string) => void | Promise<void>;
};

export default function Login({ onContinueWithoutLogin, onSuccess }: LoginProps) {
  const {
    activeStepIndex,
    steps,
    isCpfStep,
    isCodeMethodStep,
    isCodeStep,
    isSuccessStep,
    isLoading,
    isDisabled,
    verifyData,
    selectedMethod,
    handleUserVerified,
    handleMethodSelected,
    handleMethodChanged,
    handleVerified,
    handleLoadingChange,
    handleContinueWithoutLogin
  } = LoginViewModel({ onContinueWithoutLogin, onSuccess });

  return (
    <Card disabled={isDisabled} aria-disabled={isDisabled}>
      <HiddenStepper activeStep={activeStepIndex}>
        {steps.map(step => (
          <Step key={step} />
        ))}
      </HiddenStepper>

      {isCpfStep && (
        <CpfStep
          onUserVerified={handleUserVerified}
          onLoadingChange={handleLoadingChange}
          onContinueWithoutLogin={handleContinueWithoutLogin}
        />
      )}

      {isCodeMethodStep && verifyData && (
        <CodeMethodStep
          verifyData={verifyData}
          onMethodSelected={handleMethodSelected}
          onLoadingChange={handleLoadingChange}
          onContinueWithoutLogin={handleContinueWithoutLogin}
        />
      )}

      {isCodeStep && verifyData && selectedMethod && (
        <CodeStep
          verifyData={verifyData}
          method={selectedMethod}
          onVerified={handleVerified}
          onLoadingChange={handleLoadingChange}
          onContinueWithoutLogin={handleContinueWithoutLogin}
          onMethodChanged={handleMethodChanged}
        />
      )}

      {isSuccessStep && <SuccessStep />}

      {isLoading && <FooterProgress />}
    </Card>
  );
}
